module.exports = __webpack_public_path__ + "static/media/VGProLanding.c1f8f658.png";